 
  import { mapEntityProperties } from '@/utils/mapEntityProperties'
  import moment from 'moment'
  import { dayOfWeekOrder } from '@/shared/enums/DayOfWeekOrder'
import { ShowCasePeriodEntity } from '../../domain/entities/ShowCasePeriodEntity'
  
  export class ShowCasePeriodModel extends ShowCasePeriodEntity {
    constructor(dataDto: ShowCasePeriodEntity) {
      super()
  
      // Calculate day of week for start time
      const dayOfWeek = dataDto.startTimeDayOfWeek || dataDto.endTimeDayOfWeek
  
      // Handle start time
      const formattedStartTime = dataDto.startTime
        ? moment.utc(dataDto.startTime).isValid()
          ? moment.utc(dataDto.startTime).format('HH:mm')
          : moment.utc(moment(dataDto.startTime, 'HH:mm').format('')).format('HH:mm')
        : undefined
  
      // Handle end time
      const formattedEndTime = dataDto.endTime
        ? moment.utc(dataDto.endTime).isValid()
          ? moment.utc(dataDto.endTime).format('HH:mm')
          : moment.utc(moment(dataDto.endTime, 'HH:mm').format('')).format('HH:mm')
        : undefined
  
      // Calculate day of week changes for UTC conversion
      let startTimeDayOfWeek = dataDto.startTimeDayOfWeek
      let endTimeDayOfWeek = dataDto.endTimeDayOfWeek
  
      if (dataDto.startTime && dayOfWeek) {
        const startTimeLocal = moment(dataDto.startTime, 'HH:mm')
        const startTimeUtc = moment(startTimeLocal).utc()
  
        // If UTC day differs from local day
        if (startTimeLocal.format('dddd') !== startTimeUtc.format('dddd')) {
          const dayIndex = dayOfWeekOrder.findIndex((day) => day === dayOfWeek)
          const previousDay =
            dayOfWeekOrder[dayIndex - 1] || dayOfWeekOrder[dayOfWeekOrder.length - 1]
          startTimeDayOfWeek = previousDay
        }
      }
  
      if (dataDto.endTime && dayOfWeek) {
        const endTimeLocal = moment(dataDto.endTime, 'HH:mm')
        const endTimeUtc = moment(endTimeLocal).utc()
  
        // If UTC day differs from local day
        if (endTimeLocal.format('dddd') !== endTimeUtc.format('dddd')) {
          const dayIndex = dayOfWeekOrder.findIndex((day) => day === dayOfWeek)
          const previousDay =
            dayOfWeekOrder[dayIndex - 1] || dayOfWeekOrder[dayOfWeekOrder.length - 1]
          endTimeDayOfWeek = previousDay
        }
      }
  
      mapEntityProperties<ShowCasePeriodModel>(this, {
        startTime: formattedStartTime,
        endTime: formattedEndTime,
        startTimeDayOfWeek: startTimeDayOfWeek,
        endTimeDayOfWeek: endTimeDayOfWeek,
        id: dataDto.id
      })
    }
  }
  